import { IconProps } from './types';

export function MyClasses({ size, ...props }: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} fill="none" viewBox="0 0 26 26" {...props}>
      <path
        fill="currentColor"
        d="M13.31 23.698a4.04 4.04 0 0 1-2.032-.542l-6.187-3.573a4.09 4.09 0 0 1-2.031-3.52V8.938a4.09 4.09 0 0 1 2.03-3.521l6.188-3.573a4.046 4.046 0 0 1 4.063 0l6.187 3.573a4.09 4.09 0 0 1 2.032 3.52v7.126a4.09 4.09 0 0 1-2.032 3.52l-6.187 3.573a4.04 4.04 0 0 1-2.031.542Zm0-20.833c-.428 0-.865.114-1.25.333L5.872 6.77a2.507 2.507 0 0 0-1.25 2.167v7.124c0 .886.48 1.72 1.25 2.167l6.188 3.573c.77.448 1.729.448 2.5 0l6.187-3.573a2.507 2.507 0 0 0 1.25-2.166V8.938a2.52 2.52 0 0 0-1.25-2.167L14.56 3.198a2.553 2.553 0 0 0-1.25-.333Z"
      />
      <path
        fill="currentColor"
        d="M13.31 12.239a3.21 3.21 0 0 1-3.208-3.208 3.21 3.21 0 0 1 3.208-3.209 3.21 3.21 0 0 1 3.208 3.209 3.21 3.21 0 0 1-3.208 3.208Zm0-4.854a1.65 1.65 0 0 0-1.646 1.646c0 .906.74 1.645 1.646 1.645a1.65 1.65 0 0 0 1.646-1.645 1.65 1.65 0 0 0-1.646-1.646ZM17.476 18.136a.787.787 0 0 1-.781-.781c0-1.438-1.521-2.615-3.386-2.615-1.864 0-3.385 1.177-3.385 2.615a.787.787 0 0 1-.781.781.787.787 0 0 1-.782-.781c0-2.302 2.22-4.177 4.948-4.177 2.73 0 4.948 1.875 4.948 4.177a.787.787 0 0 1-.781.781Z"
      />
    </svg>
  );
}
